import { render } from "./ParticipantForm.vue?vue&type=template&id=04cdde5b&scoped=true"
import script from "./ParticipantForm.vue?vue&type=script&lang=js"
export * from "./ParticipantForm.vue?vue&type=script&lang=js"

import "./ParticipantForm.vue?vue&type=style&index=0&id=04cdde5b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cdde5b"]])

export default __exports__